import {BaseBrandedView, BaseBrandedViewOptions} from "./_BaseViews";
import * as _ from "lodash";
var template = require('templates/invitationAccepted.html');

interface InvitationAcceptedViewOptions extends BaseBrandedViewOptions {
    groupName: string;
}

export class InvitationAcceptedView extends BaseBrandedView {
    options: InvitationAcceptedViewOptions;

    private template = _.template(template);

    constructor(options: InvitationAcceptedViewOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
        }));
    };

    render() {
        this.$el.html(this.template({
            groupName: this.options.groupName
        }));
        return this;
    };
}


// WEBPACK FOOTER //
// ./srv/public/js/views/InvitationAcceptedView.ts